import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import CSSModules from 'react-css-modules';
import {Scrollbars} from 'react-custom-scrollbars';
import Button from 'toluna-react-components/Inputs/Button';
import Checkbox from 'toluna-react-components/Inputs/Checkbox';
import CheckboxesPanel from './CheckboxesPanel';
import SearchBox from './SearchBox';
/*import InputField from 'toluna-react-components/Inputs/InputField';
 import Icon from 'toluna-react-components/Icon';
 import InputFieldWithIcon from 'toluna-react-components/Inputs/InputFieldWithIcon';
 import ScrollBar from 'toluna-react-components/Containers/Scroll';*/
import {find as lodashFind} from 'lodash';
import styles from './styles.scss';


class MultipleChoiceFilter extends Component {
  constructor(props) {
	super(props);

	this.name = 'MultipleChoiceFilter';

	const {
		title,
		options = [],
		searchQuery,
		isAllSelected,
		selectAllTitle = '(',
		totalFilterItemCount,
		clearStr = '',
		noOptionsStr = '',
		loadMoreStr = '',
		applyStr = '',
		cancelStr = '',
		filterSelectionCountStr,
		filterAllSelectionCountStr,
		selectAllCountStr,
		hasMore
	} = {...this.props.filterData};

	console.log(this.name, ' created: ', this.props);

	this.closeFilter = this.closeFilter.bind(this);
	/*this.buildFilterOptions = this.buildFilterOptions.bind(this);*/
	this.getButtonsBlock = this.getButtonsBlock.bind(this);
	this.onItemValueChange = this.onItemValueChange.bind(this);
	this.onSearchValueChange = this.onSearchValueChange.bind(this);
	this.onSearchKeyUp = this.onSearchKeyUp.bind(this);
	this.onSearchApply = this.onSearchApply.bind(this);
	this.onFilterApply = this.onFilterApply.bind(this);
	this.onLoadMore = this.onLoadMore.bind(this);

	this.toggleSelectAll = this.toggleSelectAll.bind(this);
	this.isAllSelected = this.isAllSelected.bind(this);

	this.onToggleAllVisibleValues = this.onToggleAllVisibleValues.bind(this);

	const optionsClone = [...options].map((option) => {
	  return {...option};
	});

	this.state = {
	  filterValue: searchQuery || '',
	  title,
	  options: optionsClone,
	  isSelectAll: isAllSelected || false,
	  selectAllChanged: false,
	  selectAllText: selectAllTitle,
	  totalFilterItemCount,
	  clearStr,
	  loadMoreStr,
	  applyStr,
	  cancelStr,
	  noOptionsStr,
	  filterSelectionCountStr,
	  filterAllSelectionCountStr,
	  selectAllCountStr,
	  hasMore: this.props.filterData.hasMore,
	  chunkSize: 10,
	  searchQuery,
	  lastFilterItemIndex: (this.props.filterData.columnId == 'tags' ? (options.length) : options.length + 1),
	  showViewMoreLoadingIcon: false
	};
  }

  componentDidMount() {
	if (this.isAllSelected(this.state.options)) {
	  //this.setState({isSelectAll: true});
	}
	if (this.state.isSelectAll === true) {
	  //this.toggleSelectAll(this.state.isSelectAll);
	} else if (this.isAllSelected()) {
	  /* this.setState({
	   isSelectAll: true
	   });*/
	}


  }

  componentWillReceiveProps(nextProps) {
	const stateObject = {};

	console.log('New props: ', nextProps);

	if (nextProps) {
	  if (JSON.stringify(nextProps.filterData.options) !== JSON.stringify(this.props.filterData.options)) {
		/*stateObject.isSelectAll = this.isAllSelected(nextProps.filterData.options);*/
		stateObject.options = nextProps.filterData.options;
		stateObject.lastFilterItemIndex = (this.props.filterData.columnId == 'tags' ? (stateObject.options.length) : stateObject.options.length + 1),
			this.setState({
			  showViewMoreLoadingIcon: false,
			  hasMore: this.props.filterData.hasMore
			});
		console.log('options changed');
	  }
	  if (JSON.stringify(nextProps.filterData.searchQuery) !== JSON.stringify(this.props.filterData.searchQuery)) {
		stateObject.searchQuery = nextProps.filterData.searchQuery;
		console.log('query changed');
	  }


	}
	console.log('State will be added: ', stateObject);
	this.setState({...stateObject}, (state) => {
	  if (nextProps.filterData.isAllSelected !== this.state.isSelectAll) {
		console.log('Toggling explicitly selectAll');
		//this.toggleSelectAll(nextProps.filterData.selectAll);
	  }
	});
  }

  render() {
	//console.log(this.state);
	const selectedOptionsCount = this.state.options.filter((option) => {
	  return option.selected === true;
	}).length;

	//console.log(this.state.isSelectAll, this.state.selectAllChanged);
	var less = this.props.filterData.columnId == 'tags' ? 1 : 0;

	const {
		title,
		filterValue,
		options,
		isSelectAll,
		selectAllText,
		totalFilterItemCount,
		clearStr,
		noOptionsStr,
		filterSelectionCountStr,
		filterAllSelectionCountStr,
		selectAllCountStr,
		hasMore
	} = this.state;

	return (
		<div styleName="multiple-choice-filter">
		  <div styleName="title">{title}</div>
		  <SearchBox
			  value={filterValue}
			  onValueChange={this.onSearchValueChange}
			  onKeyUp={this.onSearchKeyUp}
			  onApply={this.onSearchApply}
			  searchPh={this.props.filterData.searchPh}
		  />

		  {
			options &&
			//options.length > 0 &&
			<CheckboxesPanel
				options={options}
				isSelectAll={isSelectAll}
				selectAllText={selectAllText}
				onItemValueChange={this.onItemValueChange}
				onToggleSelectAll={this.toggleSelectAll}
				onToggleAllVisibleValues={this.onToggleAllVisibleValues}
				totalFilterItemCount={totalFilterItemCount + (this.props.filterData.columnId == 'tags' ? 1 : 0)}
				clearStr={clearStr}
				noOptionsStr={noOptionsStr}
				filterSelectionCountStr={filterSelectionCountStr}
				filterAllSelectionCountStr={filterAllSelectionCountStr}
				selectAllCountStr={selectAllCountStr}
				hasMore={hasMore}
			/>
		  }

		  {this.props.filterData.hasMore == true && this.getLoadMoreBlock()}
		  {this.getButtonsBlock()}
		</div>
	);
  }

  closeFilter() {
	this.props.closeFilter();
  }

  isAllSelected(options) {
	let isAllSelected = true;
	const list = options ? options : this.state.options;

	if (options) {
	  console.log('Checking explicit options: ', options);
	}

	for (let i = 0; i < list.length; i++) {
	  let option = list[i];
	  isAllSelected = isAllSelected && option.selected;

	  //console.log(option.selected);
	}
	//console.log(isAllSelected);
	return isAllSelected;
  }

  onToggleAllVisibleValues(explicitValue) {
	const {options} = this.state;
	const newOptions = [];
	const isAllSelected = this.isAllSelected();

	if (typeof explicitValue === 'boolean' && explicitValue === true) {
	  /*newIsSelectAll = explicitValue;
	   console.log('Setting explicit selectAll: ', explicitValue);*/
	}

	[...options].map((option) => {
	  option.selected = !isAllSelected;
	  newOptions.push(option);
	});
	
	this.setState({options: newOptions, isSelectAll: !isAllSelected});
  }

  toggleSelectAll(explicitValue) {
	const {options, isSelectAll} = this.state;
	const newOptions = [];
	let newIsSelectAll = !isSelectAll;
	console.log("toggleSelectAll(explicitValue)")
	if (typeof explicitValue === 'boolean' && explicitValue === true) {
	  newIsSelectAll = explicitValue;
	  console.log('Setting explicit selectAll: ', explicitValue);
	}

	[...options].map((option) => {
	  option.selected = newIsSelectAll;
	  newOptions.push(option);
	});

	this.setState({options: newOptions, isSelectAll: newIsSelectAll, selectAllChanged: true});
  }

  getButtonsBlock() {
	//console.log('Options: ', this.state.options);
	const canApply = this.state.options.filter((option) => (option.selected === true)).length > 0;
	return (
		<div styleName="buttons-block">
		  <Button
			  styleName="btnCancel"
			  onClick={this.closeFilter}
			  buttonStyle={Button.BUTTON_STYLE.CENTERED_CONTENT}
			  text={this.props.filterData.cancelStr}
			  small
		  />
		  <Button
			  disabled={!canApply}
			  styleName="btnApply"
			  onClick={this.onFilterApply}
			  buttonStyle={Button.BUTTON_STYLE.RECTANGLE}
			  text={this.props.filterData.applyStr}
			  small
			  primary
		  />
		</div>
	);
  }

  getLoadMoreBlock() {
	return (
		<div styleName="load-more-block">
		  {this.state.showViewMoreLoadingIcon &&
		  <span styleName="loading-ph"><i className="fa fa-spinner fa-spin fa-3x fa-fw"></i></span>}
		  <Button styleName="btnLoadMore" onClick={this.onLoadMore} buttonStyle={Button.BUTTON_STYLE.OVAL_WITH_ICON}
				  iconName="plus" iconType="toluna"
				  text={this.props.filterData.loadMoreStr} small/>
		</div>
	);
  }

  onItemValueChange(item) {
	//console.log('Value changed for: ', item);
	const {selected, name, id} = item;
	const optionsClone = [...this.state.options];
	const changedOption = lodashFind(optionsClone, {id});

	if (changedOption) {
	  changedOption.selected = !changedOption.selected;

	  this.setState({options: optionsClone, isSelectAll: this.isAllSelected(optionsClone)});
	}
  }

  onSearchKeyUp(evt) {
	if (evt.keyCode === 13) {
	  this.props.searchInFilter(evt.target.value);
	}
  }

  onSearchValueChange(evt) {
	//console.log('ValueChange: ', evt);
	this.setState({
	  filterValue: evt.target.value
	});
  }

  onSearchApply(evt) {
	this.props.searchInFilter(this.state.filterValue);
  }

  onLoadMore(evt) {
	this.setState({
	  showViewMoreLoadingIcon: true
	});
	this.props.loadMore({
	  chunkSize: this.state.chunkSize,
	  lastFilterItemIndex: this.state.lastFilterItemIndex,
	  isSelectAll: this.state.isSelectAll,
	  selectAllChanged: this.state.selectAllChanged,
	  searchQuery: this.state.searchQuery
	});
  }

  onFilterApply(evt) {
	this.props.applyFilter({
	  options: [...this.state.options],
	  isSelectAll: this.state.isSelectAll,
	  selectAllChanged: this.state.selectAllChanged
	});
  }
}

export default CSSModules(MultipleChoiceFilter, {...styles}, {allowMultiple: true});


MultipleChoiceFilter.propTypes = {
  searchInFilter: PropTypes.func.isRequired,
  applyFilter: PropTypes.func.isRequired,
  loadMore: PropTypes.func.isRequired,
  closeFilter: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./components/qual/Table/TableHeader/TableHeaderCell/TableColumnFilter/FilterTypes/MultipleChoice/MultipleChoice_component.js